<template lang="pug">
  y-dialog(v-model="showModal" fill-height fluid scrollable persistent :fullscreen="$vuetify.breakpoint.xsOnly" max-width="600px")
    v-card
      v-card-title.h6.basic800--text.pa-4 {{ $t('areas_of_coverage') }}
      v-divider.basic300
      v-card-text.pa-4
        div.d-flex.align-center
          div.s1.primary--text {{ $t('enable_selected_delivery') }}
          v-spacer
          div
            y-switch.pa-0.mb-n3(v-model="enabledRestrict" hide-details)
        div.my-2.c1.primary400--text(v-if="enabledRestrict") {{ $t('customers_outside_no_payment') }}
        v-treeview(v-if="enabledRestrict" v-model="cities" selected-color="primary" selectable dense open-on-click :items="states")
      v-card-actions
        v-spacer
        v-btn.button-AA-small(color="grey" text @click="showModal=false") {{ $t('cancel') }}
        v-btn.button-AA-small.white--text(depressed color="info500" height="32" :loading="isLoading" @click="updateCities()") {{ $t('save') }}
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'ZoneCityList',
  props: ['open', 'company', 'zone'],
  data: (v) => ({
    enabledRestrict: false,
    cities: v.zone.cities,
    states: [],
    isLoading: false,
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  watch: {
  },
  mounted () {
    this.fetchCities()
    if (this.cities !== null) {
      this.enabledRestrict = true
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    updateCities () {
      this.isLoading = true
      if (!this.enabledRestrict) {
        this.cities = null
      }
      this.axios.patch(`/shipping/settings/${this.company.slug}/zones/${this.zone.id}/`, { cities: this.cities })
        .then((response) => {
          this.$emit('update:zone', response.data)
        })
        .catch(() => {})
        .finally(() => {
          this.isLoading = false
          this.showModal = false
        })
    },
    fetchCities() {
      this.$axios.get(`/shipping/postcodes/cities`)
        .then((response) => {
          this.states = response.data
          this.cities = [...this.cities] // Hack to trigger treeview reactivity
        })
        .catch(() => {})
    },
  }
}
</script>

<i18n>
{
  "en": {
    "areas_of_coverage": "Areas of Coverage",
    "enable_selected_delivery": "Enable selected delivery area",
    "customers_outside_no_payment": "Customers outside selected delivery areas will not be able to make payment"
  },
  "ms": {
  },
  "id": {
     "areas_of_coverage": "Area Cakupan",
    "enable_selected_delivery": "Aktifkan area pengiriman yang dipilih",
    "customers_outside_no_payment": "Pelanggan di luar area pengiriman yang dipilih tidak akan dapat melakukan pembayaran"
  }
}
</i18n>
